import React from 'react';
import ContactDetail_Comp from '../../Components/ContactDetail/ContactDetail';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function ContactDetail() {
  return (
    <>
    <Dashboard_Comp>
    <ContactDetail_Comp />
    </Dashboard_Comp>
    </>
  )
}

export default ContactDetail;